import React from 'react';
import { Col, Row, Card } from 'reactstrap';
import { Input, ISelectOption, DatePicker } from 'react-ocean-forms-bootstrap';
import { KomponententypSelect, PCCreatableSelect, ComponentAsyncSelect } from '../Forms';
import { ComponentCard } from './ComponentCard';
import { ViewConfig } from '../viewConfig.types';
import { Gate } from '@oceanjs/core';
import { DimensionQuery } from '../../graphql/Components';
import { useRole } from '../../hooks';
import { Role } from '../../Roles';
import { KomponenteStatus } from '../../generated/types';


interface ComponentFormProps {
  componentType?: ISelectOption;
  onComponentTypeSelect?(selected: ISelectOption): void;
  viewConfig: ViewConfig;
  componentStatus?: KomponenteStatus;
}

/**
 * @author Jungwirth
 */
export const ComponentForm: React.FC<ComponentFormProps> = (props: Readonly<ComponentFormProps>): JSX.Element => {
  const { componentType, onComponentTypeSelect = () => {}, viewConfig, componentStatus } = props;
  const role = useRole();

  return (
    <React.Fragment>
      <Card body className="mb-2">
        <Row>
          <Col>
            <KomponententypSelect
              name="component_name"
              label="component_name"
              value={componentType}
              {...viewConfig.fields.component_name.field}
              onSelect={onComponentTypeSelect} />
          </Col>
          <Col>
            <Gate handle={role === Role.EHPC_RW || componentStatus === KomponenteStatus.Ks2A || componentStatus === KomponenteStatus.Ks2B || componentStatus === undefined}>
              <Input
                name="code"
                label="code"
                {...viewConfig.fields.code.field}
                disabled={componentType === undefined || viewConfig.fields.code.field.disabled} />
            </Gate>
            <Gate handle={componentStatus === KomponenteStatus.Ks1 && role !== Role.EHPC_RW}>
              <Input
                name="codeDraft"
                label="code"
                {...viewConfig.fields.code.field}
                disabled={componentType === undefined || viewConfig.fields.code.field.disabled} />
            </Gate>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              name="name"
              label="name"
              {...viewConfig.fields.name.field}
              disabled={componentType === undefined || viewConfig.fields.name.field.disabled}
            />  
          </Col>
        </Row>
      </Card>

      
      
      {/* Stoff, Probenvorbehandlung, Methode, Sonstiges Kriterium, Matrix */}
      <ComponentCard componentType={componentType?.value} typeList={['STOFF', 'NICHTSTOFFLICH', 'PROBENVORBEHANDLUNG', 'METHODE', 'SONSTIGES_KRITERIUM', 'MATRIX']}>
        <Input
          type="textarea"
          name="annotations"
          label="annotations"
          {...viewConfig.fields.annotations.field}
        />
      </ComponentCard>
      {/* Stoff */}
      <ComponentCard componentType={componentType?.value} typeList={['STOFF']}>
        <React.Fragment>
          <Row>
            <Col md={6}>
              <Input
                name="casnumber"
                label="cas_number"
                {...viewConfig.fields.casnumber.field}
              />
            </Col>
            <Col md={6}>
              <Input
                name="sumformula"
                label="sumformula"
                {...viewConfig.fields.sumformula.field}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                name="eunumber"
                label="eu_number"
                {...viewConfig.fields.eunumber.field}
              />
            </Col>
            <Col md={6}>
              <Gate handle={!viewConfig.fields.alternativname.field.hidden}>
                <PCCreatableSelect
                  name="alternativnamen"
                  label="alternate_names"
                  createLabel="new_alternate_name"
                  {...viewConfig.fields.alternativname.field}
                />
              </Gate>
            </Col>
          </Row>
        </React.Fragment>
      </ComponentCard>
      {/* Dimension, Einheit */}
      <ComponentCard componentType={componentType?.value} typeList={['DIMENSION','EINHEIT']}>
        <Row>
          <Col md={6}>
            <Input
              name="symbol"
              label="symbol"
              {...viewConfig.fields.symbol.field}
            />
          </Col>
        </Row>
      </ComponentCard>
      {/* Einheit */}
      <ComponentCard componentType={componentType?.value} typeList={['EINHEIT']}>
        <Col>
          <Row>
            <Col md={6}>
              <ComponentAsyncSelect
                name="dimension"
                query={DimensionQuery.getPagedComponents()}
                path="dimensionen"
                fieldConfig={viewConfig.fields.dimension.field}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                name="iso_code"
                label="iso_code"
                {...viewConfig.fields.iso_code.field}
              />
            </Col>
          </Row>
        </Col>
      </ComponentCard>
      {/* Methode */}
      <ComponentCard componentType={componentType?.value} typeList={['METHODE']}>
        <Col>
          <Row>
            <Col md={12}>
              <Input
                name="titel"
                label="titel"
                {...viewConfig.fields.titel.field}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DatePicker
                name="valid_from"
                label="valid_from"
                //@ts-ignore
                inputFormat={['DD.MM.YYYY', 'D.M.YY', 'D.M.YYYY']}
                dateFormat="DD.MM.YYYY"
                timeFormat={false}
                {...viewConfig.fields.valid_from.field}
              />
            </Col>
          </Row>
        </Col>
      </ComponentCard>
    </React.Fragment>
  );
};

